var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-10"},[_c('v-card-title',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_c('vue-apex-charts',{attrs:{"type":"line","options":_vm.chartOptions,"series":_vm.series,"height":"450px"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }